import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * Internal dependencies
 */

import BaseButtonBlockAppender from '../button-block-appender';
import withClientId from './with-client-id';
export const ButtonBlockAppender = _ref => {
  let {
    clientId,
    showSeparator,
    isFloating,
    onAddBlock,
    isToggle
  } = _ref;
  return createElement(BaseButtonBlockAppender, {
    className: classnames({
      'block-list-appender__toggle': isToggle
    }),
    rootClientId: clientId,
    showSeparator: showSeparator,
    isFloating: isFloating,
    onAddBlock: onAddBlock
  });
};
export default withClientId(ButtonBlockAppender);
//# sourceMappingURL=button-block-appender.js.map